module.exports = __webpack_public_path__ + "d056245f00806e06201481e2f0a4b0f5.MP3";